module.exports = __webpack_public_path__ + "static/media/pricingPopup.be0198bc.svg";